module.exports = __webpack_public_path__ + "img/hr-icon-03.af664a77.png";